import it from './it';
import en from './en';
import fr from './fr';
import ar from './ar';
import es from './es';
import de from './de';
import ru from './ru';

export const translations = {
  it,
  en,
  fr,
  ar,
  es,
  de,
  ru
};

export const languages = [
  { code: 'it', name: 'Italiano', flag: '🇮🇹', dir: 'ltr' },
  { code: 'en', name: 'English', flag: '🇬🇧', dir: 'ltr' },
  { code: 'fr', name: 'Français', flag: '🇫🇷', dir: 'ltr' },
  { code: 'ar', name: 'العربية', flag: '🇸🇦', dir: 'rtl' },
  { code: 'es', name: 'Español', flag: '🇪🇸', dir: 'ltr' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪', dir: 'ltr' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺', dir: 'ltr' }
];

export const getLanguageByCode = (code) => {
  return languages.find(lang => lang.code === code) || languages[0];
};

export default translations;
